import { FormStep } from "./components/FormStep";
import { SentStep } from "./components/SentStep";

export interface SessionMagicLinkViewProps {
  /** Which panel to show: the email form, or the "we sent it" confirmation. */
  step: "form" | "sent";
  /** Masked recipient address; the sent panel only renders once this is present. */
  maskedEmail: string | null;
  /** Deep link into the recipient's webmail inbox, when the domain is known. */
  inboxUrl: string | null;
  email: string;
  emailError?: string;
  isPending: boolean;
  onClose: () => void;
  onBack: () => void;
  onEmailBlur?: () => void;
  onEmailChange: (value: string) => void;
  onSubmit: () => void;
}

/**
 * Presentational body of the magic-link modal: picks between the email entry
 * form and the post-send confirmation. Wiring (routing, precognition form,
 * modal chrome) lives in the container.
 */
export function SessionMagicLinkView({
  step,
  maskedEmail,
  inboxUrl,
  email,
  emailError,
  isPending,
  onClose,
  onBack,
  onEmailBlur,
  onEmailChange,
  onSubmit,
}: SessionMagicLinkViewProps) {
  return step === "sent" && maskedEmail ? (
    <SentStep inboxUrl={inboxUrl} onBack={onBack} onClose={onClose} />
  ) : (
    <FormStep
      email={email}
      emailError={emailError}
      isPending={isPending}
      onClose={onClose}
      onEmailBlur={onEmailBlur}
      onEmailChange={onEmailChange}
      onSubmit={onSubmit}
    />
  );
}
